export const environment = {
  production: true,
  api: 'https://api.heylista.com'
};
